// TRIL-239: the /verify-identity status screen. Stateless — server (login) + the approval
// email are the truth. Three converging entry paths: router state from a blocked login,
// ?inquiry-id from Persona's redirect, or a bare visit. No disabled controls.
import { Link, useLocation } from 'react-router-dom';
import { apiRoutes } from '../../constants/api-routes.constants';
import styles from './VerifyIdentity.module.scss';

interface IdvState {
  idvStatus?: string;
  idvAttempts?: number;
}

export default function VerifyIdentity() {
  const location = useLocation();
  const state = (location.state as IdvState | null) ?? {};

  if (state.idvStatus === 'DECLINED') {
    // No self-service retry path ships yet (re-launch is a deferred follow-up), so the copy
    // points to appeal/support rather than promising a "try again" that login would block.
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>{'Verification didn\'t pass'}</h1>
        <p className={styles.body}>
          {'We couldn\'t verify your identity. If you believe this is a mistake, you can appeal.'}
        </p>
        <p className={styles.hint}>
          Need help? <a href="mailto:support@trilirivos.com">Contact support</a>.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{"We're verifying your identity"}</h1>
      <p className={styles.body}>
        {"We'll email you the second it's approved — then you can sign in."}
      </p>
      <p className={styles.hint}>
        Already verified? <Link to={apiRoutes.LOGIN}>Sign in</Link>.
      </p>
    </div>
  );
}
